import { BillableIcon } from "app/components/Icons";
import clsx from "clsx";
import React, { FC } from "react";

interface BillableSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
}

const BillableSwitch: FC<BillableSwitchProps> = ({
  checked,
  onChange,
  className,
}) => {
  return (
    <button
      type="button"
      onClick={() => onChange(!checked)}
      className={clsx("inline-flex items-center cursor-pointer", className)}
    >
      <BillableIcon checked={checked} />
    </button>
  );
};

export default BillableSwitch;
